import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Loader = ({ show }) => {
  const [messages, setMessages] = useState("Loading ...");
  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      setMessages(getNextMessage(count));
      count++;
    }, 3000); // Change the interval duration as needed (here, 2 seconds)

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const getNextMessage = (index) => {
    switch (index) {
      case 0:
        return "Please wait, your PDF is being prepared...";
      case 1:
        return "It's taking some time, please be patient.";
      case 2:
        return "Still processing... Almost there!";
      case 3:
        return "Just a little more time, almost done!";
      default:
        return "Processing..."; // Default message
    }
  };
  return (
    <Wrapper>
      <div></div>
      {show && (
        <div className='message'>
          <div>{messages}</div>
        </div>
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999;
  background: #000 url(/images/loader.gif)
  no-repeat center center;
  background-size: 150px 150px;
  height: 100%;
  width: 100%;
  opacity: 0.5;

  .message {
    position: fixed;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
  }
`;

export default Loader;
